/**
 * A failure the page can turn into a sentence. The reason is a key rather than a message, because
 * every string a customer reads has to exist in both languages — and NCALayer's own text does not.
 */
export class NcaLayerError extends Error {
    constructor(
        readonly reason: 'unavailable' | 'timeout' | 'refused' | 'unreadable' | 'empty',
        readonly detail?: string
    ) {
        super(reason);
        this.name = 'NcaLayerError';
    }
}
